export const TOAST_ERROR_MESSAGE = 'Server error. Contact tech support for assistance.'

export const REQUIRED_MESSAGE = 'This field is required'

export const TEST_IDS = {
  addCarrierLink: 'add-carrier-link',
  addTeamLink: 'add-team-link',
  userAddedAt: 'user-added-at',
  carrierDOT: 'carrier-dot-number',
  carrierMC: 'carrier-mc-number',
  carrierName: 'carrier-name',
  carrierStatusHeaderSection: 'carrier-status-section',
  carrierStatusTag: 'carrier-status-tag',
  contactSupportMessage: 'contact-support-message',
  finishSetupLink: 'finish-setup-link',
  infoCards: 'info-cards',
  infoTooltip: 'info-tooltip',
  pendingAccessCard: 'carrier-pending-access-card',
  motorCarrierSelect: 'carrier-profile-header-motor-carrier-select',
  removeCarrierConfirmationModal: 'remove-carrier-confirmation-modal',
  removeCarrierLink: 'remove-carrier-link',
  startSetupLink: 'start-setup-link',
  smartWayCarrierModal: 'smart-way-carrier',
  teamMemberCount: 'team-member-count',
  teamLink: 'team-link',
}
